import React from 'react';
import { motion } from 'framer-motion';
import { Target, Wifi, RefreshCw, Globe } from 'lucide-react';
import { fadeInUp, staggerContainer } from '../hooks/useScrollAnimation';
import SectionHeading from './common/SectionHeading';
import GlassPanel from './common/GlassPanel';

const stats = [
  {
    value: 'EUR 1–5M',
    label: 'Modelled annual revenue',
    sub: 'Range across club sizes. Your figure depends on your supporter base.',
  },
  {
    value: 'EUR 0',
    label: 'Your investment',
    sub: 'ESF funds the build and supports your rollout and operations.',
  },
  {
    value: '1–2 hrs',
    label: 'Weekly club effort',
    sub: 'Automation handles the rest — no IT project on your side.',
  },
];

const features = [
  { icon: Target, label: 'Closed-loop attribution' },
  { icon: Wifi, label: 'Online + offline tracking' },
  { icon: RefreshCw, label: 'Automated settlement' },
  { icon: Globe, label: 'Growing merchant network' },
];

const RevenueProposition = () => {
  return (
    <section id="revenue" className="relative py-24 md:py-32 bg-esf-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="The ESF Advantage"
          headline="Revenue without the risk"
          subheadline="The club brings the supporters. ESF brings the platform, the funding and the merchant network."
        />

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
          className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          {stats.map((stat) => (
            <motion.div key={stat.label} variants={fadeInUp}>
              <GlassPanel className="p-8 text-center h-full">
                <p className="text-display-md md:text-5xl font-extrabold text-gradient mb-3">
                  {stat.value}
                </p>
                <p className="text-body-lg font-semibold text-esf-white mb-2">{stat.label}</p>
                <p className="text-body-sm text-esf-gray-500 text-pretty">{stat.sub}</p>
              </GlassPanel>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-50px' }}
          className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4"
        >
          {features.map((feature) => (
            <motion.div key={feature.label} variants={fadeInUp}>
              <GlassPanel className="p-4 h-full flex items-center gap-3">
                <feature.icon size={18} className="text-esf-blue flex-shrink-0" aria-hidden="true" />
                <span className="text-body-sm text-esf-gray-100 font-medium">{feature.label}</span>
              </GlassPanel>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default RevenueProposition;
